module.exports = __webpack_public_path__ + "static/bg-3a5f14d7d000cfd6f28a5100d38dbb46.png";